/**
 * Selected work — backend systems, APIs, and real-world complexity only.
 * Copy lives in locales (projects.items.<id>); this file holds URLs, stack, and flags.
 */

export const selectedProjects = [
  {
    id: "aws-infra-report",
    type: "personal",
    stack: ["Python", "boto3", "AWS", "Mermaid"],
    repoUrl: "https://github.com/franpandol/aws-infra-report",
    demoUrl: "",
    image: null,
    featured: false,
  },
  {
    id: "unofficial-mural-python-client",
    type: "personal",
    stack: ["Python", "Pydantic", "httpx", "OAuth2", "Typer"],
    repoUrl: "https://github.com/franpandol/unofficial-mural-python-client",
    demoUrl: "",
    image: null,
    featured: false,
  },
  {
    id: "lebenslauf-generator",
    type: "personal",
    stack: ["Python", "Pydantic", "Jinja2", "WeasyPrint", "Pyodide"],
    repoUrl: "https://github.com/franpandol/lebenslauf-generator",
    demoUrl: "",
    image: null,
    featured: false,
  },
];
